<template>
    <div class="flex flex-col -my-1" :class="{ 'opacity-50': disabled }">
        <transition-group name="shrink">
            <div v-for="option in practitionersDisplayFormat" :key="option.employeeId">
                <input
                    :value="option.employeeId"
                    :checked="option.employeeId == practitionerId"
                    type="radio"
                    class="absolute invisible"
                />
                <div
                    class="inline-block w-full px-6 py-3 mb-2 rounded-sm cursor-pointer"
                    :class="
                        option.employeeId === practitionerId
                            ? 'active bg-blue-500 text-white'
                            : 'bg-grey-100 text-blue-500'
                    "
                    @click="handleSelect(option.employeeId)"
                >
                    <div class="flex">
                        <div
                            class="relative w-12 h-12 mr-4 overflow-hidden rounded-full bg-grey-200"
                        >
                            <img
                                v-if="option.image"
                                :src="option.image.url"
                                class="relative top-0 left-0 object-cover w-full h-full"
                                alt=""
                            />
                        </div>
                        <div class="flex flex-col justify-center">
                            <p>{{ option.firstName }} {{ option.surname }}</p>
                            <p v-if="showNextAppointment && option.soonestApt" class="small">
                                Available from: {{ option.soonestApt }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { DateTime } from 'luxon';

export default {
    props: {
        practitioners: {
            type: Array,
            required: true
        },
        appointments: {
            type: Array,
            required: true
        },
        practitionerId: {
            type: [Number, null],
            default: null
        },
        showNextAppointment: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        practitionersDisplayFormat() {
            // Sort
            const practs = [...this.practitioners].sort((a, b) =>
                a.firstName.localeCompare(b.firstName)
            );

            // Only practitioners with upcoming appointments
            return practs.reduce((acc, current) => {
                const soonestApt = this.nextAppointment(current.employeeId);
                return soonestApt ? [...acc, { ...current, soonestApt }] : acc;
            }, []);
        }
    },

    methods: {
        practitionerAppointments(practitionerId) {
            return this.appointments.filter((apt) => apt.practitionerId === practitionerId);
        },

        nextAppointment(practitionerId) {
            const availability = this.practitionerAppointments(practitionerId);
            const soonest = availability.reduce((acc, current) => {
                const start = DateTime.fromISO(current.appointmentDateTime);
                if (!acc) return start;
                return start < acc ? start : acc;
            }, null);
            return soonest && soonest.toFormat('cccc, dd/MM/yy');
        },

        handleSelect(employeeId) {
            if (!this.disabled) {
                this.$emit('select', employeeId);
            }
        }
    }
};
</script>
